// ABOUTME: Subscription notice icon with exclamation mark in circle
// ABOUTME: Drawn in currentColor — `color` when given, else `text-gray-800`, so it follows the theme

import { cn } from "@shared/lib/utils"

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const SubscribeNoticeIcon = ({ className = "", size = 14, color }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("text-gray-800", className)}
    style={color ? { color } : undefined}
  >
    <path
      d="M7 14.25C5.66498 14.25 4.35994 13.8541 3.2499 13.1124C2.13987 12.3707 1.27471 11.3165 0.763816 10.0831C0.252925 8.84971 0.119252 7.49251 0.379702 6.18314C0.640153 4.87377 1.28303 3.67104 2.22703 2.72703C3.17104 1.78303 4.37377 1.14015 5.68314 0.879702C6.99251 0.619252 8.34971 0.752925 9.58312 1.26382C10.8165 1.77471 11.8707 2.63987 12.6124 3.7499C13.3541 4.85994 13.75 6.16498 13.75 7.5C13.748 9.28961 13.0362 11.0054 11.7708 12.2708C10.5054 13.5362 8.78961 14.248 7 14.25ZM7 2.1C5.93198 2.1 4.88795 2.41671 3.99992 3.01007C3.1119 3.60343 2.41977 4.44679 2.01105 5.43351C1.60234 6.42023 1.4954 7.50599 1.70376 8.55349C1.91212 9.60099 2.42642 10.5632 3.18163 11.3184C3.93683 12.0736 4.89902 12.5879 5.94651 12.7962C6.99401 13.0046 8.07977 12.8977 9.06649 12.489C10.0532 12.0802 10.8966 11.3881 11.4899 10.5001C12.0833 9.61206 12.4 8.56802 12.4 7.5C12.3984 6.06833 11.8289 4.69575 10.8166 3.6834C9.80425 2.67105 8.43168 2.10161 7 2.1Z"
      fill="currentColor"
    />
    <path
      d="M7 8.85C6.82098 8.85 6.64929 8.77888 6.52271 8.6523C6.39612 8.52571 6.325 8.35402 6.325 8.175V4.8C6.325 4.62098 6.39612 4.44929 6.52271 4.32271C6.64929 4.19612 6.82098 4.125 7 4.125C7.17902 4.125 7.35071 4.19612 7.4773 4.32271C7.60389 4.44929 7.675 4.62098 7.675 4.8V8.175C7.675 8.35402 7.60389 8.52571 7.4773 8.6523C7.35071 8.77888 7.17902 8.85 7 8.85Z"
      fill="currentColor"
    />
    <path
      d="M7 10.875C7.37279 10.875 7.675 10.5728 7.675 10.2C7.675 9.82721 7.37279 9.525 7 9.525C6.62721 9.525 6.325 9.82721 6.325 10.2C6.325 10.5728 6.62721 10.875 7 10.875Z"
      fill="currentColor"
    />
  </svg>
)
